/**
 * Fuente única: cuestionarios soportados por el wizard del paciente
 * (TabletCuestionario.jsx · usado para email y tablet/QR).
 *
 * Si añades soporte para un nuevo cuestionario en TabletCuestionario.jsx
 * (schema importado, mapeo questionnaireSchemas, función de scoring, y
 * render de su tipo de pregunta si es no estándar), añádelo también aquí.
 * Si no, el envío al paciente vía email/tablet quedará BLOQUEADO en el
 * frontend y rechazado defensivamente en TabletCuestionario.
 *
 * Histórico: bug observado 2026-05-20 · admin lanzaba VAS/EQ5D/PSFS/SRS22r/SAQ
 * por email y el wizard del paciente mostraba pantalla verde vacía tras
 * consentimiento+firma porque no tenía el schema importado.
 */

/* 🔴 EL EQ-5D-5L NO ESTÁ AQUÍ, Y NO ES UN OLVIDO · NO LO AÑADAS.
 *
 * `eq5d5l` está montado en el CRM desde febrero de 2026 (schema + pantalla de
 * consulta) y aparece como «Consulta», no como «Enviable». Es DELIBERADO:
 *
 *   · LEGAL   · el EQ-5D-5L es del EuroQol Group y los textos oficiales de
 *               las preguntas REQUIEREN LICENCIA (ver la nota de cabecera de
 *               eq5d5lSchema.js). Ann la va a pedir; hasta que la tenga, no
 *               se le manda a ninguna paciente.
 *   · CLÍNICO · lo que hay implementado usa textos PROPIOS («versión simple»).
 *               Con las preguntas cambiadas ya NO es un EQ-5D validado: el
 *               resultado no se puede comparar con la literatura ni con otras
 *               clínicas. Y choca con la norma de Ann: los cuestionarios
 *               clínicos oficiales no se modifican.
 *
 * Y hay un tercer motivo, técnico: el asistente de la paciente sabe pintar
 * `radio`, `scale`, `faces` y `text`, y el EQ-5D usa `eq5d_dimension` y
 * `vas_scale`. Añadirlo a esta lista SIN pintar esos dos tipos reproduce el
 * bug del 20-may-2026 — pantalla en blanco después de firmar el consentimiento.
 *
 * CUANDO LLEGUE LA LICENCIA (Ann avisará), hay que hacer las tres cosas:
 *   1. poner los textos OFICIALES en EQ5D5L_CONFIG
 *   2. pintar `eq5d_dimension` y `vas_scale` en TabletCuestionario.jsx
 *   3. y solo entonces añadir 'eq5d5l' aquí y a la lista de etiquetas
 * (Ann + agente FisioVisión, 28-ago-2026)
 */
export const SUPPORTED_PATIENT_QUESTIONNAIRES = Object.freeze([
  'vas_oficial',
  'sf12',
  'dolor_mefir',
  'odi',
  'efp0',
]);

export const SUPPORTED_PATIENT_QUESTIONNAIRES_LABELS = Object.freeze({
  vas_oficial: 'EVA / VAS dolor (0-100 mm)',
  sf12: 'SF-12 (Calidad de Vida)',
  dolor_mefir: 'Escala de Dolor MEFIR',
  odi: 'Oswestry (ODI)',
  efp0: 'Estado Funcional (EFP-0)',
});

export const isPatientQuestionnaireSupported = (tipo) =>
  SUPPORTED_PATIENT_QUESTIONNAIRES.includes(tipo);

export const PATIENT_UNSUPPORTED_MESSAGE =
  'Solo disponible en consulta. Este cuestionario todavía no puede enviarse ' +
  'al paciente por email o QR.';

export const PATIENT_UNSUPPORTED_BADGE = 'Solo en consulta';
